import { EmptyDataDash } from "@/components/EmptyDataDash";
import { Row } from "@/components/Row";
import { Avatar } from "@/components/quick-access/Avatar";

export const OwnerAvatars = ({
  ownerUserIds,
  userInitialsMap,
}: {
  ownerUserIds: number[];
  userInitialsMap: Record<number | string, string>;
}) => {
  if (ownerUserIds.length === 0) {
    return <EmptyDataDash />;
  }

  return (
    <Row className="items-center gap-1">
      {ownerUserIds.map((userId) => (
        <Avatar key={userId} initials={userInitialsMap[userId] ?? "?"} />
      ))}
    </Row>
  );
};
